import { cn } from "@/libs/cn";

const FilterBar = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={cn("w-full flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-2 p-4 bg-white rounded-lg", className)}>
    {children}
  </div>
);

// O "Lado Esquerdo" (Busca + Filtro Mobile)
FilterBar.Mobile = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={cn("flex items-center gap-2 w-full sm:flex-1 sm:min-w-85", className)}>{children}</div>
);

// O "Lado Direito" (Filtros extras + Botão de Ação)
FilterBar.Desktop = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={cn("hidden sm:flex sm:flex-wrap items-center gap-2 min-w-0", className)}>{children}</div>
);

// Slot para um filtro comum (quebra de linha ou largura padrão)
FilterBar.Item = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={cn("hidden sm:block sm:flex-1 sm:min-w-57.5", className)}>{children}</div>
);

export { FilterBar };
